import React, { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading, KPITile } from "../components/Common";
import { useAuth } from "../lib/auth";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

export default function StaffPortal() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [subjects, setSubjects] = useState([]);
  useEffect(() => {
    api.teacherOverview().then(({ data }) => setData(data));
    api.subjects().then(({ data }) => setSubjects(data));
  }, []);
  const subjMap = useMemo(() => Object.fromEntries(subjects.map((s) => [s.id, s])), [subjects]);
  if (!data) return <Loading />;

  const gridByClass = (data.classes || []).map((c) => {
    const rows = (data.timetable || []).filter((t) => t.class_id === c.id);
    return { class: c, rows };
  });

  return (
    <div data-testid="staff-portal">
      <PageHeader kicker="Teacher Portal" title={`Welcome, ${user?.full_name}`} subtitle="Your classes, timetable and student roster." />
      <div className="grid grid-cols-3 gap-4 mb-6">
        <KPITile tone="dark" testId="tp-classes" label="My classes" value={(data.classes || []).length} />
        <KPITile testId="tp-students" label="Students" value={(data.students || []).length} />
        <KPITile testId="tp-lessons" label="Weekly lessons" value={(data.timetable || []).length} />
      </div>

      {gridByClass.map(({ class: c, rows }) => (
        <Section key={c.id} title={c.name}>
          <div className="hl-card overflow-x-auto mb-4">
            <table className="hl-table">
              <thead>
                <tr>
                  <th>Period</th>
                  {DAYS.map((d) => <th key={d}>{d}</th>)}
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5].map((p) => (
                  <tr key={p}>
                    <td className="font-semibold">P{p}</td>
                    {DAYS.map((d) => {
                      const e = rows.find((r) => r.day === d && r.period === p);
                      return (
                        <td key={d}>
                          {e ? (
                            <>
                              <div className="text-sm font-semibold">{subjMap[e.subject_id]?.name}</div>
                              <div className="text-xs text-slate-500">Room {e.room}</div>
                            </>
                          ) : <span className="text-slate-300">—</span>}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Section>
      ))}

      <Section title="My student roster">
        <DataTable
          columns={[
            { key: "name", label: "Student", render: (r) => `${r.first_name} ${r.last_name}` },
            { key: "year_group", label: "Year" },
            { key: "house", label: "House" },
            { key: "boarding", label: "Boarding", render: (r) => r.boarding ? "Yes" : "No" },
          ]}
          rows={(data.students || []).slice(0, 40)}
        />
      </Section>
    </div>
  );
}
